import * as React from 'react'
import { LogLevel } from '../model'
import Select from '@mulesoft/anypoint-components/lib/Select'
import './LogPointsLogLevelSelector.css'
import LogLevelOption from './LogLevelOption/LogLevelOption'

export type ValueProps = {
  logLevelOptions: LogLevel[]
  selected?: LogLevel
  testId?: string
  className?: string
}

export type EventProps = {
  onLogLevelChange: (logLevel: LogLevel) => void
}

export type Props = ValueProps & EventProps

export type State = {
  selected?: LogLevel
}

class LogPointsLogLevelSelector extends React.PureComponent<Props, State> {

  private static optionRenderer(option: {value: LogLevel, label: string}) {
    const props = {logLevel: option}

    return (
      <LogLevelOption {...props}/>
    )
  }

  constructor(props: Props) {
    super(props)

    const {selected, logLevelOptions} = props

    this.state = {
      selected: selected || (logLevelOptions.length > 0 ? logLevelOptions[0] : undefined)
    }

    this.onSelectorChange = this.onSelectorChange.bind(this)
  }

  onSelectorChange(e: { value: LogLevel }) {
    this.setState({selected: e.value})
    this.props.onLogLevelChange(e.value)
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, prevContext: any): void {
    const {selected} = this.props
    if (prevProps.selected !== selected) {
      this.setState({selected})
    }
  }

  render() {
    const {selected} = this.state
    const {className, testId, logLevelOptions} = this.props
    const options = logLevelOptions.map(logLevel => ({value: logLevel, label: logLevel}))
    const value = options.find(option => option.value === selected)

    return (
      <Select
        className={className}
        options={options}
        testId={testId}
        onChange={this.onSelectorChange}
        value={value}
        optionRenderer={LogPointsLogLevelSelector.optionRenderer}
      />
    )
  }
}

export default LogPointsLogLevelSelector
